import { invariant } from '@seen/core/invariant'
import { createContext, useContext } from 'react'
import type { FieldError, FieldPath, FieldValues } from 'react-hook-form'

interface UseFormFieldReturn<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> {
  name: TName
  formItemId: string
  formDescriptionId: string
  formErrorMessageId: string
  invalid: boolean
  isTouched: boolean
  isDirty: boolean
  isValidating: boolean
  error?: FieldError
}

export function useFormField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(): UseFormFieldReturn<TFieldValues, TName> {
  const formFieldContext = useContext(FormFieldContext) as UseFormFieldReturn<
    TFieldValues,
    TName
  >
  invariant(formFieldContext, 'Missing FormField in the tree')
  return formFieldContext
}

export const FormFieldContext = createContext<UseFormFieldReturn>(
  {} as UseFormFieldReturn
)
